export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
console.log("Current BACKEND_URL:", BACKEND_URL);

export async function uploadPartnerImage(img) {
  const requestOptions = {
    headers: {
      'Content-Type': img.type
    },
    method: 'POST',
    body: img,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/home/admin/partners-img/${img.name}`, requestOptions);
}

export async function deletePartnerImage(imgName) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/home/admin/partners-img/${imgName}`, requestOptions);
}

export async function getHomePagePartnersImageName() {
  return await fetch(`${BACKEND_URL}/home/partners-img-name`);
}

export async function getHomePagePartnersImage() {
  return await fetch(`${BACKEND_URL}/home/partners-img`);
}

export async function getHomePageInfo() {
  return await fetch(`${BACKEND_URL}/home/info`);
}

export async function updateHomePageInfo(body) {
  body = JSON.stringify(body);

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/home/admin/info`, requestOptions);
}

export async function handleSignUp(username, password, confirmPassword) {
  const body = JSON.stringify({
    username,
    password,
    confirmPassword
  });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body
  };

  return await fetch(`${BACKEND_URL}/accounts/signup`, requestOptions);
}

export async function verifyEmail(email, code) {
  const body = JSON.stringify({ email, code });
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body
  };
  return await fetch(`${BACKEND_URL}/accounts/verify-email`, requestOptions);
}

export async function resendVerificationCode(email) {
  const body = JSON.stringify({ email });
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body
  };
  return await fetch(`${BACKEND_URL}/accounts/resend-verification-code`, requestOptions);
}

export async function handleLogin(username, password) {
  const body = JSON.stringify({
    username,
    password
  });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/accounts/login`, requestOptions);
}

export async function handleChangePassword(oldPassword, newPassword) {
  const body = JSON.stringify({ oldPassword, newPassword });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/accounts/change-password`, requestOptions);
}

export async function handleResetPassword(email) {
  const body = JSON.stringify({ email });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/accounts/reset-password`, requestOptions);
}

export async function updateAccount(accountInfo) {
  const body = JSON.stringify(accountInfo);

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/accounts`, requestOptions);
}

export async function upgradeAccount(username, action, accountType, entityName, sector, sectorName) {
  const body = JSON.stringify({
    username,
    action,
    accountType,
    entityName,
    sector,
    sectorName
  });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/accounts/upgrade-account`, requestOptions);
}

export async function requestUpgradeAccount(accountType, entityName, sector, sectorName) {
  const body = JSON.stringify({
    requestAccountType: accountType,
    entityName,
    sector,
    sectorName
  });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };
  return await fetch(`${BACKEND_URL}/accounts/upgrade-account-request`, requestOptions);
}

export async function updateThreshold(_id, currentThreshold) {
  const body = JSON.stringify({
    threshold: currentThreshold
  });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };
  return await fetch(`${BACKEND_URL}/productions/cert-data/update-threshold/${_id}`, requestOptions);
}

export async function handleLogout() {
  return await fetch(`${BACKEND_URL}/accounts/logout`, { credentials: 'include' });
}

export async function getAdminHomeAccountsInfo(query) {
  return await fetch(`${BACKEND_URL}/accounts/all${query ? `?query=${query}` : ''}`, { credentials: 'include' });
}

export async function getAdminHomeEventsInfo() {
  return await fetch(`${BACKEND_URL}/home/admin/events`, { credentials: 'include' });
}

export async function getCertificateIssuerHomeInfo(page, pageSize) {
  let url = `${BACKEND_URL}/productions/get-events`;
  if (page && pageSize) {
    url += `?page=${page}&limit=${pageSize}`;
  }
  return await fetch(url, { credentials: 'include' });
}

export async function getCertificateReceiverHomeInfo() {
  return await fetch(`${BACKEND_URL}/certs`, { credentials: 'include' });
}

export async function addNewProduction(productionName, year, fieldConfigs) {
  // Sector is now fetched from account on backend - no longer passed from frontend
  const body = JSON.stringify({ productionName, year, fieldConfigs });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/new`, requestOptions);
}

export async function deleteEvent(eventId) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/${eventId}`, requestOptions);
}

export async function updateEvent(eventInfo) {
  const eventInfoCopy = { ...eventInfo };
  const { _id } = eventInfoCopy;
  delete eventInfoCopy._id;
  const body = JSON.stringify(eventInfoCopy);

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/${_id}`, requestOptions);
}

export async function verifyCert(certId, latitude, longitude) {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const username = isLoggedIn ? localStorage.getItem('username') : '';
  console.log(username);
  const accountType = isLoggedIn ? localStorage.getItem('accountType') : '';
  const time = new Date().toString();
  const body = JSON.stringify({
    certId,
    latitude,
    longitude,
    isLoggedIn,
    username,
    accountType,
    time
  });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body
  };

  return await fetch(`${BACKEND_URL}/verify`, requestOptions);
}

export async function getCertData(eventId) {
  const requestOptions = {
    method: 'GET',
    credentials: 'include'
  };
  return await fetch(`${BACKEND_URL}/productions/cert-data/${eventId}`, requestOptions);
}

export async function uploadCertData(eventId, payload) {
  const body = JSON.stringify(payload);
  console.log('inside requests.js - uploadCertData()', { eventId, payload });
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/cert-data/${eventId}`, requestOptions);
}

export async function confirmCsvUpload(eventId) {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  };
  
  return await fetch(`${BACKEND_URL}/productions/cert-data/confirm/${eventId}`, requestOptions);
}

export async function getCertImage(eventId) {
  const requestOptions = {
    method: 'GET',
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/cert-image/${eventId}`, requestOptions);
}

export async function uploadCertImage(img, eventId) {
  const requestOptions = {
    headers: {
      'Content-Type': img.type
    },
    method: 'POST',
    body: img,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/cert-image/${eventId}`, requestOptions);
}

export async function getCertPreview(eventId, email, columnMapping, qrCodeMapping, displayQrCode) {
  columnMapping = columnMapping.map(col => {
    const copy = { ...col };
    delete copy.placeholders;
    return copy;
  });
  const body = JSON.stringify({ columnMapping, email, qrCodeMapping: displayQrCode ? qrCodeMapping : null });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/preview-cert/${eventId}/${email}`, requestOptions);
}

export async function submitEventColumnMapping(eventId, columnMapping, qrCodeMapping, displayQrCode) {
  columnMapping = columnMapping.map(col => {
    const copy = { ...col };
    delete copy.placeholders;
    return copy;
  });
  const body = JSON.stringify({ columnMapping, qrCodeMapping: displayQrCode ? qrCodeMapping : null });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/column-mapping/${eventId}`, requestOptions);
}

export async function getEmailTemplatePreview(eventId, email, template) {
  const body = JSON.stringify({ eventId, email, template });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/email-template/preview`, requestOptions);
}

export async function uploadEmailTemplate(eventId, emailTemplate) {
  const body = JSON.stringify({ emailTemplate });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/productions/email-template/${eventId}`, requestOptions);
}

export async function searchUserCertificates(email) {
  return await fetch(`${BACKEND_URL}/certs/user-certs/${email}`, { credentials: 'include' });
}

export async function issueCertificates(eventId) {
  return await fetch(`${BACKEND_URL}/productions/issue-certs/${eventId}`, { credentials: 'include' });
}

export async function downloadQrs(eventId) {
  return await fetch(`${BACKEND_URL}/productions/download-qrs/${eventId}`, { credentials: 'include' });
} 

export async function downloadScanStats(id) {
  return await fetch(`${BACKEND_URL}/productions/cert-data/fetch-stats/${id}`, { credentials: 'include' });
}

export async function updateProgram(body) {
  body = Object.assign({}, body);
  const _id = body._id;
  delete body._id;

  if (body.programDate) {
    body.programDate = Date.parse(body.programDate);
  }
  body = JSON.stringify(body);

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/programs/${_id}`, requestOptions);
}

export async function addProgram(programImg, programUrl, programName, programDate, programDescription) {
  const body = JSON.stringify({ programImg, programUrl, programName, programDate, programDescription });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/programs`, requestOptions);
}

export async function getAllPrograms(excludeImg = false, excludeHtml = true, excludeCss = true) {
  return await fetch(`${BACKEND_URL}/programs/?excludeImg=${excludeImg || ''}&excludeHtml=${excludeHtml || ''}&excludeCss=${excludeCss || ''}`, { credentials: 'include' });
}

export async function getProgramHtml(_id) {
  return await fetch(`${BACKEND_URL}/programs/html/${_id}`, { credentials: 'include' });
}

export async function getProgramCss(_id) {
  return await fetch(`${BACKEND_URL}/programs/css/${_id}`, { credentials: 'include' });
}

export async function deleteProgram(programId) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/programs/${programId}`, requestOptions);
}

export async function getCertsRemaining() {
  return await fetch(`${BACKEND_URL}/certs/remaining-count`, { credentials: 'include' });
}

export async function getAccountUpgradeRequest() {
  const requestOptions = {
    method: 'GET',
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/accounts/get-account-upgrade-request`, requestOptions);
}

export async function createCheckoutSession(amt) {
  const body = JSON.stringify({ amt });

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/checkout/create`, requestOptions);
}

export async function getPurchaseHistory() {
  return await fetch(`${BACKEND_URL}/checkout/purchase-history`, { credentials: 'include' });
}

// ===== SECTOR TEMPLATE API FUNCTIONS =====

export async function getSectorTemplates() {
  return await fetch(`${BACKEND_URL}/sectors`, { credentials: 'include' });
}

export async function getSectorTemplate(sectorCode) {
  return await fetch(`${BACKEND_URL}/sectors/${sectorCode}`, { credentials: 'include' });
}

export async function createSectorTemplate(sectorData) {
  const body = JSON.stringify(sectorData);

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/sectors`, requestOptions);
}

export async function updateSectorTemplate(sectorCode, updateData) {
  const body = JSON.stringify(updateData);

  const requestOptions = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'PUT',
    body,
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/sectors/${sectorCode}`, requestOptions);
}

export async function deleteSectorTemplate(sectorCode) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include'
  };

  return await fetch(`${BACKEND_URL}/sectors/${sectorCode}`, requestOptions);
}
